import React, { useState, useEffect} from 'react';
import { getCurrentUTCDate } from '@utility/common_utils';

const WorkoutTimer = React.memo(({ startedAt, isActive }) => {
  const [duration, setDuration] = useState('00:00:00');
  
  useEffect(() => {
    let timer;
    
    if (startedAt) {
      const calculateDuration = () => {
        const now = getCurrentUTCDate();
        const start = new Date(startedAt);
        const diff = now - start;
        
        const hours = Math.floor(diff / (1000 * 60 * 60)).toString().padStart(2, '0');
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
        const seconds = Math.floor((diff % (1000 * 60)) / 1000).toString().padStart(2, '0');
        
        setDuration(`${hours}:${minutes}:${seconds}`);
      };
      
      calculateDuration();
      
      timer = setInterval(calculateDuration, 1000);
    } else {
      setDuration('00:00:00');
    }
    
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [startedAt]); // only reruns if startedat changes
  
  return (
    <div className={`workout-timer ${isActive ? 'active' : ''}`}>
      {duration}
    </div>
  );
});

export default WorkoutTimer;